"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "propValueFromCurrentTheme", {
  enumerable: true,
  get: function get() {
    return _ThemeProvider.propValueFromCurrentTheme;
  }
});
Object.defineProperty(exports, "getValueFromPath", {
  enumerable: true,
  get: function get() {
    return _ThemeProvider.getValueFromPath;
  }
});
Object.defineProperty(exports, "getFromPalette", {
  enumerable: true,
  get: function get() {
    return _ThemeProvider.getFromPalette;
  }
});

var _ThemeProvider = require("./ThemeProvider");